import type { BranchMember } from '@/entities/Branch';

export function buildMemberOptions(members: BranchMember[]) {
  return members
    .filter((member): member is BranchMember & { id: number } => member.id !== undefined)
    .map((member) => ({ id: member.id, name: member.user?.name ?? '' }));
}
